import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import * as qs from "query-string";
import parameters from "./config/parameters";

const publicIp = require("public-ip");

function Test() {
  const [headersResponse, setHeadersResponse] = useState({});
  const [headersRequest, setHeadersRequest] = useState({});
  const [ip, setIp] = useState();
  const location = useLocation();

  const queries = qs.parse(location.search);
  const { subscription } = queries;

  useEffect(() => {
    (async () => {
      const ipAddress = await publicIp.v4();
      setIp(ipAddress);
      // alert(`ip :${ipAddress}`);
      //  console.log(`ip :${ipAddress}`);
    })();
    fetch(`${parameters.notifApi}`)
      .then((response) => {
        // console.log("response :>> ", response);
        return response.json();
      })
      .then((res) => {
        // console.log(res);
        setHeadersRequest(res.data);
      });

    const req = new XMLHttpRequest();
    req.open("GET", document.location, false);
    req.send(null);

    // associate array to store all values

    const data = {};

    // get all headers in one call and parse each item

    const headers = req.getAllResponseHeaders().toLowerCase();
    const aHeaders = headers.split("\n");

    for (let i = 0; i < aHeaders.length - 1; i += 1) {
      const thisItem = aHeaders[i];

      const key = thisItem.substring(0, thisItem.indexOf(":"));

      const value = thisItem.substring(thisItem.indexOf(":") + 1);

      data[key] = value;
    }
    // console.log("header  :>> ", data);
    // alert(headers);
    setHeadersResponse(data);
  }, []);

  useEffect(() => {
    setTimeout(() => {
      window.location.replace(
        `${parameters.paiementUrl}/paiement?subscription=${subscription}`
      );
    }, parameters.waitingTimeTest);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {}, []);
  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <div style={{ margin: "3rem" }}>
        <b>ip Address : </b>
        <span>{ip}</span>
      </div>

      <div style={{ margin: "3rem" }}>
        <p>
          <b>header Request : </b>
        </p>
        {Object.keys(headersRequest).map((keyName, i) => (
          <li className="travelcompany-input" key={i}>
            <span className="input-label">
              {keyName} :{headersRequest[keyName]}
            </span>
          </li>
        ))}
      </div>

      <div style={{ margin: "3rem" }}>
        <p>
          <b>header Response : </b>
        </p>
        {Object.keys(headersResponse).map((keyName, i) => (
          <li className="travelcompany-input" key={i}>
            <span className="input-label">
              {keyName} :{headersResponse[keyName]}
            </span>
          </li>
        ))}
      </div>
    </div>
  );
}

export default Test;
